import useApi from '../../../services/useApi'

const useGetPurchasers = () => {
  const Api = useApi()

  const {data: response, isFetching} = Api.useGetQuery('/purchaser/analytics/mapped/users', {
    queryId: 'purchasers',
  })

  return {
    purchasers:
      response?.data?.map((item: any) => ({
        label: item.name,
        value: item.email_id,
      })) || [],
    isLoading: isFetching,
  }
}

export default useGetPurchasers
